import React, { useState, useEffect } from 'react'
import ScoringLeadersHomeNavigation from './ScoringLeadersHomeNavigation'
import SelectLeagueForScoringLeaders from '../UIElements/SelectLeagueForScoringLeaders'
import Footer from '../UIElements/Footer'
import Banner from './Banner'
import './StatsAndStandingsHome.css'

const ScoringLeadersHome = () => {
	console.log('inside ScoringLeadersHome')

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return (
		<div style={{ overflowX: 'hidden' }}>
			<ScoringLeadersHomeNavigation />
			{!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)}
			<SelectLeagueForScoringLeaders />
		</div>
	)
}

export default ScoringLeadersHome
